import React, {ComponentType} from "react";
import FlexBox, {FlexBoxProps} from "view/components/Layout/FlexBox";
import CheckCircleSharpIcon from "@material-ui/icons/CheckCircleOutlineTwoTone";
import {Box, Typography} from "@material-ui/core";
import useStyles from "./styles";

interface StepWrapperProps extends FlexBoxProps {
  index: number;
  isComplete?: boolean;
  CustomIconComponent?: ComponentType;
}
const StepWrapper: React.FC<StepWrapperProps> = ({
  index,
  isComplete,
  children,
  CustomIconComponent,
  ...rest
}) => {
  const classes = useStyles();
  const stepperIcon = () => {
    if (CustomIconComponent) {
      return <CustomIconComponent />;
    }
    return !isComplete ? (
      <Box className={classes.stepWrapperIndex}>
        <Typography variant="h4">{index}</Typography>
      </Box>
    ) : (
      <CheckCircleSharpIcon color="primary" />
    );
  };
  return (
    <FlexBox gap={2}>
      <FlexBox column alignCenter gap={2}>
        {stepperIcon()}
        <Box className={classes.stepWrapperLeftDivider} />
      </FlexBox>
      <FlexBox column gap={3} paddingBottom={3} width="100%" {...rest}>
        {children}
      </FlexBox>
    </FlexBox>
  );
};

export default StepWrapper;
